// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"LoadingSpinner-module--loadingSpinner--1YVgO","spin":"LoadingSpinner-module--spin--37kvP"};